var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file","accept":_vm.accept,"multiple":_vm.multiple},on:{"change":_vm.handleUpload}})}
var staticRenderFns = []

export { render, staticRenderFns }